// pages/karigars/KarigarsPage.jsx
// Tab shell for everything karigar-related: who they are, what to give them, what to
// take back. Owns the page chrome (.page + header + tab strip); each panel owns its own
// data and its own live count, so nothing has to be lifted up here.
import { useState } from "react";
import { useRouter } from "../../contexts/RouterContext";
import KarigarList from "./KarigarList";
import AssignWork from "./AssignWork";
import ReturnWork from "./ReturnWork";

const TABS = [
  { key: "list",   label: "🧵 Karigars",    sub: "Registered workers, their rates and balances" },
  { key: "assign", label: "📤 Assign Work", sub: "Hand pending stitch items to a karigar" },
  { key: "return", label: "📥 Return Work", sub: "Take finished items back from a karigar" },
];

export default function KarigarsPage({ initialTab }) {
  const { navigate } = useRouter();
  // Guard against a bad route param rather than rendering a blank page.
  const [tab, setTab] = useState(
    TABS.some((t) => t.key === initialTab) ? initialTab : "list"
  );

  const active = TABS.find((t) => t.key === tab) ?? TABS[0];

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Karigars</h1>
          <p className="page-sub">{active.sub}</p>
        </div>
        {/* Only meaningful on the list tab — the work tabs have their own action button. */}
        {tab === "list" && (
          <button className="btn btn-primary" onClick={() => navigate("karigar-add")}>
            ＋ Add Karigar
          </button>
        )}
      </div>

      <div className="section-tabs">
        {TABS.map((t) => (
          <div
            key={t.key}
            className={`section-tab${tab === t.key ? " active" : ""}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </div>
        ))}
      </div>

      {/* Unmounting the inactive panels is deliberate: switching back re-fetches, so the
          assign list can't show items a colleague issued while you were on another tab. */}
      {tab === "list"   && <KarigarList />}
      {tab === "assign" && <AssignWork />}
      {tab === "return" && <ReturnWork />}
    </div>
  );
}
